import type React from 'react';
import { useEffect } from 'react';

import { roomIdSelector } from '@redux/room/selectors';
import {
  activatedVolumeSelector,
  bamSessionClientCodeSelector,
  shouldSkipStaffPasswordSelector,
} from '@redux/session/selectors';
import { userTypeSelector } from '@redux/user/selectors';
import analytics from 'lib/analytics';
import { useDispatch, useSelector } from 'react-redux';

import { B2bRoutes } from './B2bRoutes';
import Root from './components/b2b/Root';

const AppB2b: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const userType = useSelector(userTypeSelector);
  const roomId = useSelector(roomIdSelector);
  const isSkipStaffPasswordActivated = useSelector(shouldSkipStaffPasswordSelector);
  const clientCode = useSelector(bamSessionClientCodeSelector);
  const isVolumeActivated = useSelector(activatedVolumeSelector);

  useEffect(() => {
    if (roomId) {
      analytics.identify(roomId);
      analytics.clientData({
        userType,
        roomId,
        isSkipStaffPasswordActivated,
        isVolumeActivated,
      });
    }
    analytics.register({ clientCode });
  }, [isSkipStaffPasswordActivated, isVolumeActivated, roomId, userType, clientCode, dispatch]);

  return (
    <Root>
      <B2bRoutes />
    </Root>
  );
};

export default AppB2b;
